import Vue from 'vue'
import VueRouter from 'vue-router'

import Landing from './components/Home.vue';
import Landing2 from './components/Home2.vue';
import Contact from './components/Contact.vue';
import DemoVideo from './components/DemoVideo.vue';
import BookDemo from './components/BookDemo.vue';

import Families from './components/Families.vue';
import Caregivers from './components/Caregivers.vue';
import Login from './components/Login.vue'

import LandingDental from './components/HomeDental.vue';

import StripeConnectConfirmation from './components/StripeConnectConfirmation'

Vue.use(VueRouter)

const routes = [
  { path: '/', component: Landing2, name: 'Home' },
  { path: '/2', component: Landing, name: 'Home2' },
  { path: '/contact', component: Contact, name: 'Contact' },
  { path: '/demo-video', component: DemoVideo, name: 'Demo Video' },
  { path: '/book-demo', component: BookDemo, name: 'Book Demo' },

  { path: '/families', component: Families, name: 'Families' },
  { path: '/caregivers', component: Caregivers, name: 'Caregivers' },
  { path: '/login', component: Login, name: 'Login' },
  
  { path: '/dental', component: LandingDental, name: 'Home Dental' },

  { path: '/stripe-connect-confirmation', component: StripeConnectConfirmation, name: 'Stripe Connect Confirmation' },
]

export default new VueRouter({mode: 'history', routes})



// WEBPACK FOOTER //
// ./src/router.js